export const testSelectors = {
  completenessChart: 'completeness-chart',
};
